import { render, staticRenderFns } from "./optional-package.vue?vue&type=template&id=24f90a8e&scoped=true"
import script from "./optional-package.vue?vue&type=script&lang=ts"
export * from "./optional-package.vue?vue&type=script&lang=ts"
import style0 from "./optional-package.vue?vue&type=style&index=0&id=24f90a8e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f90a8e",
  null
  
)

export default component.exports